import { FC, useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { QuoteDto } from '../../dtos';
import { LoadingIndicator, useFailedCreateSnackbar, useSuccessfulCreateSnackbar } from '../../Components/CoreLib/library';
import { useCreateQuoteMutation, useLazyGetCustomerByIdQuery } from '../../store/generated/generatedApi';
import { QuoteForm } from '../../Components/Forms/QuoteForm';

export const AddQuoteView: FC = () => {
    const { customerId } = useParams();
    const navigate = useNavigate();
    const [getCustomer, { data: customer, isLoading: isCustomerLoading }] = useLazyGetCustomerByIdQuery();
    const [createQuote, { isError, isSuccess, reset }] = useCreateQuoteMutation();

    useEffect(() => {
        if (customerId && !customer) {
            getCustomer({ id: customerId! });
        }
    }, [customer, customerId, getCustomer]);

    useSuccessfulCreateSnackbar('Quote', isSuccess, reset);
    useFailedCreateSnackbar('quote', isError, reset);

    const handleSave = async (values: QuoteDto) => {
        return await createQuote(values).unwrap();
    };

    const handleCancel = () => {
        if (customerId) {
            navigate(`/customer/${customerId}/dashboard`);
        } else {
            navigate('/quotes');
        }
    };

    const handleAfterSuccessfulCreate = useCallback(
        (quote: QuoteDto) => {
            if (customerId) {
                navigate(`/customer/${customerId}/quote/${quote.id}`);
            } else {
                navigate(`/quote/${quote.id}`);
            }
        },
        [customerId, navigate]
    );

    if (isCustomerLoading) {
        return <LoadingIndicator />;
    }

    return (
        <QuoteForm
            save={handleSave}
            cancel={handleCancel}
            customer={customer}
            onAfterSuccessfulCreate={handleAfterSuccessfulCreate}
        />
    );
};
